export const permissions = {
  admin: {
    blogs: true,
    blogCreate: true,
    blogEdit: true,
    blogDelete: true,
    blogPublish: true,
  },

  dev: {
    blogs: true,
    blogCreate: true,
    blogEdit: true,
    blogDelete: true,
    blogPublish: true,
  },

  seo: {
    blogs: true,
    blogCreate: true,
    blogEdit: true,
    blogDelete: false,
    blogPublish: true,
  },
};

export const hasPermission = (permission) => {
  try {
    const user = JSON.parse(localStorage.getItem("adminUser"));

    if (!user) return false;

    return permissions[user.role]?.[permission] === true;
  } catch (error) {
    return false;
  }
};